// extracted by mini-css-extract-plugin
export default {"Intro":"Gradient_Intro__D8YnA","text":"Gradient_text__aP8Gd","How":"Gradient_How__17FzG","Img":"Gradient_Img__JBwWl"};